import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import {
  type OfferPriceV1,
  PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { priceGetFormattedPrice } from '../../../../price'
import { productAccessorGetDataNoSnippetAttributeForInsurancePrescription } from '../../../model/productAccessor/productAccessorGetDataNoSnippetAttributeForInsurancePrescription'

type RetailPriceProps = ComponentPropsWithoutRef<'span'> & {
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  isDiscountValid: boolean
  isMasterPage: boolean
  lowestPrice: number
  offerPrice: OfferPriceV1 | null
}

export const RetailPrice: FC<RetailPriceProps> = ({
  className,
  currentPrescriptionType,
  isDiscountValid,
  isMasterPage,
  lowestPrice,
  offerPrice,
  ...restProps
}) => {
  const intl = useIntl()

  const isDiscountedPrice =
    !isMasterPage &&
    (currentPrescriptionType !==
      PrescriptionPrescriptionTypeEnum.NoPrescription ||
      isDiscountValid)

  return (
    <span
      className={clsx(
        'text-3xl font-bold tablet:text-xl',
        isDiscountedPrice ? 'text-dark-error' : 'text-dark-primary-max',
        className,
      )}
      {...restProps}
      // Prevent google displaying the price on search for prescription products
      {...productAccessorGetDataNoSnippetAttributeForInsurancePrescription(
        currentPrescriptionType,
      )}
      data-qa-id="displayAmountField"
    >
      {isMasterPage ? (
        <>
          <FormattedMessage id="general.label.price.from" />{' '}
        </>
      ) : null}
      {priceGetFormattedPrice(
        (isMasterPage ? lowestPrice : offerPrice?.price) ?? 0,
        intl,
      )}
    </span>
  )
}
